import React, {useState} from "react"
import * as Yup from "yup"
import {connect} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"


// components
import LangPax from "./_langs";
import {ButtonCancel,  ButtonSubmit} from "../../../components/buttons/buttonsActions"

// labels
import {PH_CODE, PH_NAME, PH_NATIONALITY, PH_ORDER} from "../../../components/i18n/placeHolders"
import {
    FORM,
    INTERNATIONAL,
    LB_CODE,
    LB_NAME,
    LB_NATIONALITY,
    LB_ORDER,
    LB_STATUS,
    REQUIRED
} from "../../../components/i18n/i18n"

// actions
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions"

// services
import {genericActions} from "../../../redux/actions/generics/GenericActions"
import {paxService} from "../../../jwt/_services/clasificator/paxService"
import Switch from "react-bootstrap-switch";




const PaxForm = (props) => {
    const { app } = props.mainProps;
    const { editMode, domainObject } = props.formProps;
    const translatableLangs = domainObject?.translatedLangs || []

    const fbDataBase = {id: app?.fbDataBase?.id}
    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setlangs] = useState(domainObject?.langs || []);


    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
        nationality: Yup.string().required( REQUIRED ),
        showOrder: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            nationality: domainObject?.nationality,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs: langs || domainObject?.langs
            }
        };

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if (!editMode)
            genericActions.save(paxService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(paxService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }


    return <Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}
        </CardTitle>
        <CardBody className={'card-body-modal'}>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{LB_NATIONALITY}</Label>
                            <Input
                                type="text"
                                name="nationality"
                                placeholder={PH_NATIONALITY}
                                innerRef={register}
                            />
                            { errors.nationality && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.nationality?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label>{LB_ORDER}</Label>
                            <Input
                                type="number"
                                name="showOrder"
                                placeholder={PH_ORDER}
                                innerRef={register}
                            />
                            { errors.showOrder && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.showOrder?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{LB_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <LangPax
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>

                <div className="float-right">
                    <ButtonSubmit/>
                    <ButtonCancel onClick={ closeForm }/>
                </div>
            </Form>
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(PaxForm);